import React from 'react';
import '../App.css';

const Header = () => {
    return (
        <header className="App-header">
                <h1>Rat in a maze</h1>
        </header>
    );
};

export default Header;